<template>
  <DialogLayout
    title="新規追加"
    :visible.sync="dialogVisible"
    width="60em"
    @open="open"
  >
    <template #form>
      <FeesForWeightAndNoiseMasterForm
        ref="feesForWeightAndNoiseMasterForm"
        v-model="feesForWeightAndNoiseMasterFormModel"
        label-width="10em"
        formMode="register"
        billingYmMode="this"
      />
    </template>
    <template #footer>
      <RegisterDialogFooter
        @clear="clickClear"
        @register="clickRegister"
      />
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import FeesForWeightAndNoiseMasterForm from '@/components/organisms/dialog/feeMaster/FeesForWeightAndNoiseMasterForm.vue'
import RegisterDialogFooter from '@/components/organisms/dialog/RegisterDialogFooter.vue'

export default {
  components: {
    DialogLayout,
    FeesForWeightAndNoiseMasterForm,
    RegisterDialogFooter
  },
  props: {
    currentRow: {
      type: Object,
      default: () => {
        return {}
      }
    },
    visible: Boolean
  },
  data () {
    return {
      feesForWeightAndNoiseMasterFormModel: {
        charge_year: undefined,
        route_code: undefined,
        jet_type: undefined,
        paid_type: undefined,
        min_weight: 0,
        max_weight: 9999,
        weights: [{ data_range_from: 0, data_range_to: 25, charge: undefined }, { data_range_from: 26, data_range_to: 100, charge: undefined }, { data_range_from: 101, data_range_to: 200, charge: undefined }, { data_range_from: 201, data_range_to: 9999, charge: undefined }],
        noises: [{ data_range_from: undefined, data_range_to: undefined, charge: undefined }]
        // route_and_weight: [{ exemption_type_by_route_and_weight: undefined, route_airport_code: undefined, exemption_rate_by_route_and_weight: undefined }],
        // type: [{ exemption_type_by_type: undefined, type_value: undefined, exemption_rate_by_type: undefined }],
        // weights: []
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (visible) {
        this.$emit('update:visible', visible)
      }
    }
  },
  mounted () {
  },
  methods: {
    clickClear () {
      this.$refs.feesForWeightAndNoiseMasterForm.clearFields()
    },
    async clickRegister () {
      this.$loadingMask.on()
      this.$refs.feesForWeightAndNoiseMasterForm.validate()
        .then((valid) => {
          // const searchCond = JSON.parse(JSON.stringify(this.feesForWeightAndNoiseMasterFormModel))
          // return this.$axios.post('/fees-for-weight-and-noise-master', searchCond)
          return this.$axios.post('/fees-for-weight-and-noise-master', this.feesForWeightAndNoiseMasterFormModel)
        })
        .then((res) => {
          this.$fcMessage.showMessage(res.data.message)
          this.dialogVisible = false
          this.$emit('refresh', this.feesForWeightAndNoiseMasterFormModel.billing_ym)
        })
        .catch((e) => {
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message)
                break
              default:
            }
          }
        })
        .finally(() => {
          this.$loadingMask.off()
        })
    },
    open () {
      const trimItem = ['registration_symbol', 'bill_to_code', 'route_code']
      this.$nextTick(() => {
        this.$refs.feesForWeightAndNoiseMasterForm.clearFields()
        Object.keys(this.feesForWeightAndNoiseMasterFormModel)
          .forEach((x) => {
            if (trimItem.includes(x) && this.currentRow[x]) {
              this.currentRow[x] = this.currentRow[x].trimEnd()
            }
            if (this.currentRow[x] !== undefined) {
              this.$set(this.feesForWeightAndNoiseMasterFormModel, x, this.currentRow[x])
            }
          })
      })
    }
  }
}
</script>

<style lang="scss">
</style>
